import { FormValues } from '@sbercloud/uikit-product-calculator';
import {
  CONSOLE_DEV_STATIC_PAGE_LOGIN_DESTINATION_URL,
  CONSOLE_STATIC_PAGE_LOGIN_DESTINATION_URL,
} from 'src/components/TariffPlans/initialData';

import { ProductTypeConnect } from '../types';
import { transformProductDataToConsole } from './transformProductDataToConsole';

const checkSpace = () => {
  const url = window.location.href;
  const condition =
    url.indexOf('autotest') !== -1 ||
    url.indexOf('shadow') !== -1 ||
    url.indexOf('cloudtest') !== -1;

  if (
    condition ||
    process.env.NEXT_PUBLIC_SPACE === 'develop' ||
    process.env.NEXT_PUBLIC_SPACE === 'stage'
  ) {
    return 'dev';
  }

  return 'prod';
};

const getCreateVmUrl = () => {
  if (checkSpace() === 'dev') {
    return CONSOLE_DEV_STATIC_PAGE_LOGIN_DESTINATION_URL;
  }
  return CONSOLE_STATIC_PAGE_LOGIN_DESTINATION_URL;
};

/**
 * Хук возвращает функцию connectProduct при помощи которой мы отправляем
 * данные активного продукта в консоль
 */
export function connectProduct(productType: string, data: FormValues) {
  const createVmUrl = getCreateVmUrl();

  const configToConnect = transformProductDataToConsole({
    productType: productType as ProductTypeConnect,
    productData: data,
  });

  const totalUrl = `${createVmUrl}?config=${btoa(
    JSON.stringify(configToConnect),
  )}`;

  // проверка на максимальную длину - что бы url не превысил допустимый максимум
  if (totalUrl.length > 2083) {
    // eslint-disable-next-line no-console
    console.error('длина url');
    return;
  }

  window.open(totalUrl, '_blank');
}
